import { z } from 'zod';

/**
 * zod compila sus validadores con `Function` si el entorno se lo permite, y lo comprueba la
 * primera vez que se construye un schema. Bajo la CSP de producción esa comprobación falla:
 * zod cae a modo interpretado y todo sigue funcionando, pero el navegador registra una
 * violación real. Configurarlo antes de que se cargue ningún schema evita el intento.
 *
 * Se importa por su efecto y de primero en `main.tsx`: hacerlo en el cuerpo del entrypoint
 * sería tarde, porque los imports se evalúan antes.
 */
z.config({ jitless: true });
